// extracted by mini-css-extract-plugin
export var cartContainer = "_jg-4";
export var gray = "_jg-1";
export var itemContainer = "_jg-2";
export var itemDetails = "_jg-3";
export var strong = "_jg-0";